import React from "react";
import { useTranslation } from "react-i18next";
import CustomMultiSelect from "../../../Common/FormElements/MultiSelect";

const OrdersSelector = ({
  orders,
  selectedOrders,
  onOrdersChange,
  loading,
}) => {
  const { t } = useTranslation("common");

  return (
    <div className="d-flex w-100 align-items-center justify-content-between gap-5 py-2">
      <label className="f16 text-dark mb-2">{t("Orders")}</label>
      <CustomMultiSelect
        filter
        options={orders}
        value={!loading ? selectedOrders : []}
        panelClassName="bottom-50px top-unset"
        className="flex-grow-1 max-w-350px"
        placeholder={loading ? t("Loading...") : t("Select")}
        disabled={loading}
        callback={(e) => onOrdersChange(e.target.value)}
      />
    </div>
  );
};

export default OrdersSelector;
